import React from 'react';
import './WarningNotification.less';
import { CloseIcon, WarningIcon } from 'app/components/icons';
import { Trans } from 'react-i18next';

type ContentType =
  | string
  | React.ReactElement
  | { i18nKey: string; values?: Record<string, any> };
type LinkType = {
  i18nKey: string;
  onClick: () => void;
  values?: Record<string, any>;
};

interface Props {
  title: ContentType;
  subtitle?: ContentType;
  onClose?: () => void;
  link?: LinkType;
}

export default function WarningNotification({
  title,
  subtitle,
  onClose,
  link,
}: Props) {
  function renderContent(content: ContentType): React.ReactNode {
    if (typeof content === 'string') {
      return content;
    }

    if (typeof content === 'object' && 'i18nKey' in content) {
      return (
        <Trans
          {...content}
          values={content.values}
          components={{
            date: <span className="warning-notification__date" />,
          }}
        />
      );
    }

    return content;
  }

  return (
    <div className="warning-notification">
      <WarningIcon className="warning-notification__warning-icon" />

      <div className="warning-notification__content">
        <h4 className="warning-notification__title">{renderContent(title)}</h4>

        {subtitle && (
          <p className="warning-notification__description">
            {renderContent(subtitle)}
          </p>
        )}

        {link && (
          <p className="warning-notification__link" onClick={link.onClick}>
            {renderContent(link)}
          </p>
        )}
      </div>

      <CloseIcon
        className="warning-notification__close-icon"
        height={24}
        width={24}
        onClick={onClose}
      />
    </div>
  );
}
